module.exports = __webpack_public_path__ + "static/media/11.ea87f74a.jpg";